
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"19.75","y":"11.875","width":"2.25","height":"2.25","rx":"1","transform":"rotate(90 19.75 11.875)","stroke":"#112A46"}}),_c('rect',{attrs:{"x":"14.125","y":"11.875","width":"2.25","height":"2.25","rx":"1","transform":"rotate(90 14.125 11.875)","stroke":"#112A46"}}),_c('rect',{attrs:{"x":"8.5","y":"11.875","width":"2.25","height":"2.25","rx":"1","transform":"rotate(90 8.5 11.875)","stroke":"#112A46"}})])
          )
        }
      }
    